module.exports = __webpack_public_path__ + "static/media/ganaloco-final-image.7fa2b55f.png";